module.exports = "https://deal-img.imgix.net/consumer/modern/flags.58ec6947.png";